/**
 * Created by mac on 3/3/24
 */

RestoreProgressButton.OverlappingNodes = RestoreProgressButton.OverlappingNodes.concat("BoardView", "KeypadView", "CurrentView", "CookieJarView", "KingsCupMarksView", "PlayersView", "MagnifierAnimation");
